import Autocomplete from "./autocomplete"
/**
* TagsAutocomplete
*/

class TagAutocomplete {
    construtor(target, options) {
        if(!target || !target.length) return;
        if(!options) options = {};

        new Autocomplete(target, {
            blur: (options.blur) ? options.blur : false,
            clear: (options.clear) ? options.clear : false,
            source: '/common/token-tags/',

            callback: function(data) {
                if(options.callback) {
                    options.callback(data);
                }
            }
        });
    }
}

export { TagAutocomplete }
